<div class="modal-header">
  <h5 class="modal-title">
    <i class="bi bi-pencil me-2"></i>
    {{ 'TenantGroupManagement.editGroup' | translate }}
  </h5>
  <button type="button" class="btn-close" [disabled]="saving" (click)="cancel()"></button>
</div>

<div class="modal-body">
  <!-- Tabs -->
  <ul ngbNav #nav="ngbNav" [(activeId)]="activeTab" class="nav-tabs mb-3">
    <li [ngbNavItem]="'details'">
      <a ngbNavLink>
        <i class="bi bi-info-circle me-1"></i>
        {{ 'TenantGroupManagement.details' | translate }}
      </a>
      <ng-template ngbNavContent>
        <form [formGroup]="groupForm">
          <!-- Group Name -->
          <div class="mb-3">
            <label class="form-label required">
              {{ 'TenantGroupManagement.groupName' | translate }}
            </label>
            <input type="text" 
                   class="form-control" 
                   formControlName="groupName"
                   [class.is-invalid]="groupForm.get('groupName')?.invalid && groupForm.get('groupName')?.touched"
                   maxlength="100">
            <div class="invalid-feedback" *ngIf="groupForm.get('groupName')?.invalid && groupForm.get('groupName')?.touched">
              <div *ngIf="groupForm.get('groupName')?.errors?.['required']">
                {{ 'Validation.required' | translate }}
              </div>
            </div>
          </div>

          <!-- Description -->
          <div class="mb-3">
            <label class="form-label">
              {{ 'TenantGroupManagement.description' | translate }}
            </label>
            <textarea class="form-control" 
                      formControlName="description"
                      rows="3"
                      maxlength="500"></textarea>
          </div>
        </form>
      </ng-template>
    </li>

    <li [ngbNavItem]="'members'">
      <a ngbNavLink>
        <i class="bi bi-people me-1"></i>
        {{ 'TenantGroupManagement.members' | translate }}
        <span class="badge badge-soft-primary ms-1">{{ currentMembers.length }}</span>
      </a>
      <ng-template ngbNavContent>
        <!-- Add Members Section -->
        <div class="card mb-3">
          <div class="card-header bg-light">
            <h6 class="mb-0">{{ 'TenantGroupManagement.addMembers' | translate }}</h6>
          </div>
          <div class="card-body">
            <div class="mb-3">
              <label class="form-label">{{ 'TenantGroupManagement.selectTenants' | translate }}</label>
              <select class="form-select" 
                      [(ngModel)]="selectedDomainIds" 
                      multiple
                      size="5"
                      [disabled]="savingMembers || availableDomains.length === 0">
                <option *ngFor="let domain of availableDomains" [value]="domain.domainID">
                  {{ domain.domainName }}
                </option>
              </select>
              <div class="form-text" *ngIf="availableDomains.length === 0">
                {{ 'TenantGroupManagement.noAvailableTenants' | translate }}
              </div>
            </div>
            <button type="button" 
                    class="btn btn-primary btn-sm"
                    [disabled]="selectedDomainIds.length === 0 || savingMembers"
                    (click)="addMembers()">
              <span *ngIf="savingMembers" class="spinner-border spinner-border-sm me-1"></span>
              <i class="bi bi-plus-circle me-1" *ngIf="!savingMembers"></i>
              {{ 'TenantGroupManagement.addSelected' | translate }}
            </button>
          </div>
        </div>

        <!-- Current Members -->
        <div class="card">
          <div class="card-header bg-light">
            <h6 class="mb-0">{{ 'TenantGroupManagement.currentMembers' | translate }}</h6>
          </div>
          <div class="card-body">
            <div *ngIf="loadingMembers" class="text-center py-3">
              <div class="spinner-border spinner-border-sm text-primary"></div>
            </div>

            <div *ngIf="!loadingMembers && currentMembers.length === 0" class="text-center text-muted py-3">
              <i class="bi bi-inbox display-6"></i>
              <p class="mt-2 mb-0">{{ 'TenantGroupManagement.noMembers' | translate }}</p>
            </div>

            <div class="list-group" *ngIf="!loadingMembers && currentMembers.length > 0">
              <div *ngFor="let member of currentMembers" 
                   class="list-group-item d-flex justify-content-between align-items-center">
                <div>
                  <i class="bi bi-building me-2"></i>
                  {{ member.domainName }}
                </div>
                <button type="button" 
                        class="btn btn-sm btn-outline-danger"
                        (click)="removeMember(member.domainID)"
                        [title]="'General.remove' | translate">
                  <i class="bi bi-x-circle"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </li>
  </ul>

  <div [ngbNavOutlet]="nav"></div>
</div>

<div class="modal-footer">
  <button type="button" 
          class="btn btn-secondary" 
          [disabled]="saving"
          (click)="cancel()">
    {{ 'General.cancel' | translate }}
  </button>
  <button type="button" 
          class="btn btn-primary" 
          [disabled]="saving || groupForm.invalid"
          (click)="save()">
    <span *ngIf="saving" class="spinner-border spinner-border-sm me-1"></span>
    {{ 'General.save' | translate }}
  </button>
</div>

<!-- Remove Member Confirmation Modal -->
<ng-template #removeMemberModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">
      <i class="bi bi-exclamation-triangle text-warning me-2"></i>
      {{ 'TenantGroupManagement.confirmRemoveMember' | translate }}
    </h5>
    <button type="button" class="btn-close" (click)="cancelRemoveMember()"></button>
  </div>
  <div class="modal-body">
    <p>{{ 'TenantGroupManagement.confirmRemoveMemberMessage' | translate }}</p>
    <p class="fw-bold">{{ memberToRemove?.domainName }}</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="cancelRemoveMember()">
      {{ 'General.cancel' | translate }}
    </button>
    <button type="button" class="btn btn-danger" (click)="confirmRemoveMember()">
      <i class="bi bi-x-circle me-1"></i>{{ 'General.remove' | translate }}
    </button>
  </div>
</ng-template>
